<template>

    <section class="hero flex">
        <div class="hero-body flex_block">
            <div class="container has-text-centered  results_cands">

                <h1 class="title is-size-2 results_big_title">{{ $t('modules.candidates.results.title') }}</h1>



        </div>
        </div>
    </section>



</template>

<script>

export default {
    name: 'CandidateResults',
    components: {
    },
    data(){
        return {}
    },
    computed: {
        currentEval(){
            return this.$store.state.CandidateStore.results
        }
    },
}

</script>

<style lang="scss">
.results_strength_scores{
    .strength_scores{
        width: 500px;
        margin: auto;
    }
}
.results_cands{
    margin-top: 50px;

}
.results_cands p{
    font-size: 1.5rem;
    text-align: justify;
}
.strengths_results_row{
    align-items: center;
}
.s3_results_picto_row{
    display: flex;
    align-items: center;
    color: #f9bb5c!important;
    margin-top: 0;
    &.flex_end{
        justify-content: flex-end;
    }
    span{
        padding: 10px;
        img{
            width: 100px;
        }
    }
}
.title_m_t{
    margin-top: 70px;
}
.bluebloc{
    background: #4ba6e7;
    color: white;
    padding: 30px;
    font-weight: 500;
    text-align: center;
    p{
        text-align: center;
    }
    .blue_bloc_title{
        color: white;
    }
}
.grey_bloc{
    background: $white-ter;
    padding: 30px;
    margin-bottom: 50px;
}
.results_big_title{
    margin: 50px 0!important;
}
.first_notice{
    text-align: center!important;
}

</style>